var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.625,
    height: 18.66,
    viewBox: "0 0 17.625 18.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M557.121,1330.9a8.859,8.859,0,0,0-4.69-4.69.032.032,0,0,0-.028-.01,5.812,5.812,0,1,0-6.806,0,.033.033,0,0,0-.028.01,8.808,8.808,0,0,0-5.381,7.93.172.172,0,0,0,.012.07.268.268,0,0,0,.041.06.154.154,0,0,0,.061.04.191.191,0,0,0,.073.02h1.406a.186.186,0,0,0,.188-.18,7.033,7.033,0,0,1,14.062,0,.186.186,0,0,0,.188.18h1.406a.191.191,0,0,0,.073-.02.154.154,0,0,0,.061-.04.237.237,0,0,0,.041-.06.192.192,0,0,0,.013-.07A8.754,8.754,0,0,0,557.121,1330.9ZM549,1325.52a4.048,4.048,0,0,1-4.031-4.04,4.031,4.031,0,1,1,6.881,2.85A3.979,3.979,0,0,1,549,1325.52Z",
    transform: "translate(-540.188 -1315.67)",
    fill: "#1a1d20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bb38c280d6f5906f82e2abcb37063fa8.svg";
export { ForwardRef as ReactComponent };